import { render } from "./BTabs.vue?vue&type=template&id=dff00f08"
import script from "./BTabs.vue?vue&type=script&lang=js"
export * from "./BTabs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__